import * as React from 'react';
import {Platform, TouchableOpacity, View} from 'react-native';
import {Field} from 'redux-form';
import {useStyles} from '../../../../../shared/hooks/styles';
import {DeviceSize} from '../../../../../shared/theme/helpers';
import {getProductsFilterName} from '../../pipes';
import {BaseFieldWrapper} from '../../../../../shared/components/baseField';
import {PropsProductPriceList} from '../../model';
import {Text} from '../../../../../shared/components/text';
import {images} from '../../../../../assets/icons';
import {useTheme} from '../../../../../shared/theme';
import {useDimensions} from '../../../../../shared/hooks/useDimensions';

interface ViewProps extends PropsProductPriceList {
  resetMin: () => void;
  resetMax: () => void;
}

export default ({style, visuallyImpaired, resetMin, resetMax}: ViewProps) => {
  const theme = useTheme();
  const iconColor = theme.color.textColor;
  const {width} = useDimensions();
  const styles = useStyles(({mediaOnly}) => ({
    containerStyle: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-evenly',
      alignSelf: 'center',
      alignContent: 'center',
    },
    item: {
      ...mediaOnly(DeviceSize.mobile, {marginBottom: 12}, {marginBottom: 15}),
      ...(Platform.OS === 'web' ? {} : {width: '45%'}),
      flexDirection: 'row',
      width: Platform.OS === 'web' ? 150 : width / 2 - 50,
      overflow: 'hidden',
    },
    label: {
      ...mediaOnly(
        DeviceSize.mobile,
        {
          ...theme.fonts.body,
        },
        {
          ...theme.fonts.caption,
          fontSize: 20,
          lineHeight: 26,
        },
      ),
      color: theme.color.textColor,
    },
    button: {
      ...mediaOnly(DeviceSize.mobile, {marginTop: 5}),
      ...mediaOnly(DeviceSize.desktop, {marginTop: 10}),
      width: 48,
      height: 48,
      justifyContent: 'center',
      alignItems: 'center',
    },
    fieldStyle: visuallyImpaired
      ? {
          justifyContent: 'flex-start',
          paddingHorizontal: 10,
        }
      : {},
  }));

  //@ts-ignore
  const normalizeDigits = (value, _previousValue) => {
    if (!value) return value;
    const onlyDigits = value.replace(/[^\d]/g, '');
    return onlyDigits;
  };

  let inputWidth = width / 2 - 50;
  if (inputWidth > 150) inputWidth = 150;

  return (
    <View style={[styles.containerStyle, style]}>
      <View key={0} style={styles.item}>
        <Field
          component={BaseFieldWrapper}
          variant={Platform.OS === 'web' ? 'standard' : 'outlined'}
          type='number'
          name={getProductsFilterName(String(0), 'productPrice')}
          label={'От'}
          labelStyle={styles.label}
          style={styles.fieldStyle}
          normalize={normalizeDigits}
          inputContainerStyle={Platform.OS === 'web' ? {} : {backgroundColor: 'white', width: inputWidth}}
        />
        {Platform.OS === 'web' ? (
          <TouchableOpacity style={styles.button} testID={`edit-reg-card-close`} onPress={resetMin}>
            <images.Close height={24} width={24} color={iconColor} />
          </TouchableOpacity>
        ) : null}
      </View>
      {Platform.OS === 'web' ? null : (
        <View style={{marginBottom: 20, marginRight: 5}}>
          <Text>-</Text>
        </View>
      )}
      <View style={styles.item}>
        <Field
          variant={Platform.OS === 'web' ? 'standard' : 'outlined'}
          component={BaseFieldWrapper}
          type='number'
          name={getProductsFilterName(String(1), 'productPrice')}
          label={'До'}
          labelStyle={styles.label}
          style={styles.fieldStyle}
          normalize={normalizeDigits}
          inputContainerStyle={Platform.OS === 'web' ? {} : {backgroundColor: 'white', width: inputWidth}}
        />
        {Platform.OS === 'web' ? (
          <TouchableOpacity style={styles.button} testID={`edit-reg-card-close`} onPress={resetMax}>
            <images.Close height={24} width={24} color={iconColor} />
          </TouchableOpacity>
        ) : null}
      </View>
    </View>
  );
};
